module.exports = __webpack_public_path__ + "static/media/ZoomG3.210519d6.png";